// src/hooks/api/payOrder.js
//
// Отправляет данные оплаты на наш бэкенд (/api/pay).
// HMAC-подпись формируется на сервере — ключи не покидают бэкенд.
// Фронт не знает никаких секретных ключей.

export default async function payOrder(data) {
    try {
        const response = await fetch('/api/pay', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            console.error('Ошибка оплаты:', response.status);
            return null;
        }

        return await response.json();

    } catch (error) {
        console.error('Ошибка сети:', error);
        return null;
    }
}
